<div class="card shadow-sm mb-3">
  <div class="card-header" *ngIf="title">
    <h6 class="mb-0">{{title}}</h6>
  </div>
  <div class="card-body">
    <ng-content></ng-content>
  </div>
</div>